<button type="button" class="account" [matMenuTriggerFor]="profile" [title]="(email$ | async) || 'Optimus account'">
    <span class="avatar">{{ initial$ | async }}</span>
</button>

<mat-menu #profile="matMenu" xPosition="before">
    <div class="account-menu-head" *ngIf="email$ | async as email">
        <span class="account-menu-label">Signed in as</span>
        <span class="account-menu-email">{{ email }}</span>
    </div>
    <button mat-menu-item [routerLink]="['/admin/settings']">
        <mat-icon>settings</mat-icon> Settings
    </button>
    <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon> Sign out
    </button>
</mat-menu>
